import addIcon from '../../assets/icons/plus.svg'
import updateIcon from '../../assets/icons/plus.svg'
import deleteIcon from '../../assets/icons/plus.svg'
import filterIcon from '../../assets/icons/Filters lines.svg'
import filterIcon2 from '../../assets/icons/filterIcon2.svg'
import useScreenSize from '../../hooks/useScreenSize'
import './button.scss'

// button proptypes options
// variant = flat | outlined | normal
// icon = add | update | delete | "dont use icon prop if no icon"

const Button = ({
  onClick,
  type = 'submit',
  icon,
  children,
  variant = 'flat',
  customClassName,
  disabled,
  disabledBgColor,
  ...rest
}) => {
  const screenSize = useScreenSize()
  const icons = {
    add: addIcon,
    update: updateIcon,
    delete: deleteIcon,
    filter: filterIcon,
    filter2: filterIcon2,
  }
  return (
    <button
      className={`button ${screenSize} flex justify-center align-center   ${variant} ${customClassName} `}
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        backgroundColor: disabled && (disabledBgColor || 'lightgray'),
      }}
      {...rest}
    >
      {children}
      {icon && (
        <div className='icon-wrapper flex-center'>
          <img src={icons[icon]} />
        </div>
      )}
    </button>
  )
}

export default Button
